import toast from 'react-hot-toast';
import { create } from 'zustand';
import { WorkoutItem } from '../pages/workout/models/workout.domain';

const storageKey = 'playbookClipboardData';

interface WorkoutClipboardState {
  data: WorkoutItem[];
  influencerId: string;
  copy: (newData: WorkoutItem) => void;
  clearAll: () => void;
  deleteItem: (index: number) => void;
}

const initialData = () => {
  const influencerId = window.location.pathname.split('/').reverse()[3];
  const storageData = localStorage.getItem(`${storageKey}-${influencerId}`);
  return {
    data: storageData ? JSON.parse(storageData) : [],
    influencerId: influencerId,
  };
};

export const useWorkoutClipboardStore = create<WorkoutClipboardState>(
  (set, get) => ({
    ...initialData(),
    copy: (newData: WorkoutItem) => {
      const storageData = localStorage.getItem(
        `${storageKey}-${get().influencerId}`,
      );
      const currentData: WorkoutItem[] = storageData
        ? JSON.parse(storageData)
        : [];

      const alreadyExists = currentData.some((i) => i.name === newData.name);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const isCircuit = !!newData?.exercises;
      if (alreadyExists) {
        toast.success(
          `${isCircuit ? 'Circuit' : 'Exercise'} already in clipboard`,
        );
        return;
      }

      localStorage.setItem(
        `${storageKey}-${get().influencerId}`,
        JSON.stringify([...currentData, newData]),
      );
      toast.success(
        `${isCircuit ? 'Circuit' : 'Exercise'} copied to clipboard`,
      );
      return set({ data: [...currentData, newData] });
    },
    clearAll: () => {
      localStorage.removeItem(`${storageKey}-${get().influencerId}`);
      return set({ data: [] });
    },
    deleteItem: (index: number) => {
      const filteredData = get().data.filter((d, i: number) => index !== i);
      localStorage.setItem(storageKey, JSON.stringify(filteredData));
      return set({ data: filteredData });
    },
  }),
);
